<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title>推播名單</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="py-1 label">推播方式：</v-col>
          <v-col class="col-auto py-1">
            <v-radio-group v-model="notifyTypes" row hide-details class="mt-0">
              <v-radio value="line" label="Line" hide-details></v-radio>
              <v-radio value="sms" label="簡訊" hide-details></v-radio>
              <v-radio value="auto" label="Line+簡訊" hide-details></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-1 label">推播對象：</v-col>
          <v-col class="py-1">
            <v-radio-group v-model="target" row hide-details class="mt-0">
              <v-radio class="py-0 my-0" label="全部" value="all"></v-radio>
              <v-radio
                class="py-0 my-0"
                label="未填問卷"
                value="question"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-1 label">符合人數：</v-col>
          <v-col class="py-1">
            {{ matchList.length }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-1 label">推播內容：</v-col>
          <v-col class="py-1">
            <v-textarea
              v-model="content"
              hint="可用變數 {name}、{id}、{date}、{time}、{place}、{questionnaire}"
              outlined
              dense
              persistent-hint
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="dialog = false">取消</v-btn>
        <v-btn color="primary" @click="send">送出</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
export default {
  name: "PushDialog",
  props: ["value", "theList"],
  data: () => ({
    notifyTypes: "auto",
    target: "all",
    list: [],
    content:
      "{name}你好，您已預約全民健檢，請於{date} {time}至{place}，並請先點擊連結填寫問卷 {questionnaire}。",
  }),
  created() {
    this.list = _.cloneDeep(this.theList);
  },
  computed: {
    matchList() {
      let list = this.list;
      switch (this.target) {
        case "all":
          break;
        case "question":
          list = list.filter((o) => !o.report[0].外部問卷);
          break;
      }
      return list;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async send() {
      if (!this.notifyTypes) {
        this.$toast.error("請選擇推播方式！");
        return false;
      }
      if (confirm(`確認送出 ${this.matchList.length} 筆推播？`)) {
        this.$vloading.show();
        let data = (
          await this.axios.post("/dashboard/person/notifySection", {
            list: this.matchList.map((o) => ({
              name: o.姓名,
              mobile: o.電話,
              id: o.身分證字號,
              place: o.地點,
              time: o.建議時間,
              date: o.日期,
            })),
            content: this.content,
            condition: {
              type: this.notifyTypes,
              target: this.target,
            },
          })
        ).data;
        alert(
          `選擇 ${this.matchList.length} 位民眾，符合推播條件 ${data.count} 位，已加入排程推播！`
        );
        this.$vloading.hide();
        this.dialog = false;
      }
    },
  },
};
</script>

<style></style>
